import React, { Component } from 'react';
import { Nav, Navbar, NavbarBrand, NavItem } from "reactstrap";
import Aux from "../../hoc/Aux/Aux";
import Select from 'react-select';
import './Reports.css'
import moment from "moment";
import { NavLink, Redirect, Route, Switch } from "react-router-dom";
import PatientsReport from "./Patients/PatientsReport";
import TherapistsReport from "./Therapists/TherapistsReport";
import * as actions from "../../store/actions";
import { loadPatientsReportData } from "../../store/actions";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import { connect } from "react-redux";
import axios from "../../axios-cmk";
import Spinner from "../UI/Spinner/Spinner";
import VisitsReport from "./VisitsReport";

class Reports extends Component {

    constructor(props) {
        super(props);
        const periods = this.generate_periods();
        this.state = {
            periods: periods,
            activeTab: '1'
        };
    }

    componentDidMount() {
        this.props.startLoadingData();
        if (!this.props.reports_period) {
            const selected_period = this.state.periods[2];
            this.props.setReportsPeriod(selected_period);
            this.props.loadData(selected_period.value)
        } else {
            this.props.loadData(this.props.reports_period.value)
        }
    }

    generate_periods = () => {
        let result = [];
        for (let i = -2; i < 24; i++) {
            const month = moment().subtract(i, 'month');
            result.push({ 'id': i + 1, 'value': month.format('MM_YYYY'), 'label': month.format('MMMM YYYY') })
        }
        return result
    };


    handlePeriodChange = (selectedPeriod) => {
        this.props.setReportsPeriod(selectedPeriod);
        this.props.startLoadingData();
        this.props.loadData()
    };

    render() {
        const content = this.props.loading_data ? <Spinner /> : (
            <Aux>
                <Switch>
                    <Route path={this.props.match.path + '/visits'} component={VisitsReport} />
                    <Route path={this.props.match.path + '/patients'} component={PatientsReport} />
                    <Route path={this.props.match.path + '/therapists'} component={TherapistsReport} />
                    <Redirect to="/reports/visits" />
                </Switch>
            </Aux>
        );
        return (
            <Aux>
                <Navbar className="navbar navbar-expand-lg navbar-light bg-light reportsNavbar no-print">
                    <Nav tabs>
                        <NavbarBrand>Pokaż:</NavbarBrand>
                        <NavItem>
                            <NavLink to="/reports/visits" className="nav-link">Wszystkie wizyty</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to="/reports/patients" className="nav-link">Pacjenci</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to="/reports/therapists" className="nav-link">Terapeuci</NavLink>
                        </NavItem>
                        <NavbarBrand className="periodLabel"> za okres: </NavbarBrand>
                        <NavItem>
                            <Select
                                className="datePeriodSelect"
                                placeholder="Wybierz okres"
                                name="form-field-name"
                                value={this.props.reports_period}
                                onChange={this.handlePeriodChange}
                                options={this.state.periods}
                            />
                        </NavItem>
                    </Nav>
                </Navbar>
                {content}
            </Aux>
        )
    }
}

const mapStateToProps = state => {
    return {
        reports_period: state.reports.reports_period,
        loading_data: state.reports.loading_data
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadData: () => dispatch(loadPatientsReportData()),
        setReportsPeriod: (period) => dispatch(actions.setReportsPeriod(period)),
        startLoadingData: () => dispatch(actions.startLoadingData()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Reports, axios));


// WEBPACK FOOTER //
// ./src/components/Reports/Reports.js